import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { convertQueryStringToObject } from '@/helpers';
import { Environment, TESTING_SHOP } from '@/constants';

const usePostHogRecord = () => {
  const posthog = usePostHog();
  const search = convertQueryStringToObject(window.location.search);
  const isOpenFromCms = search?.scope === 'omegatheme';
  const isProduction = process.env.REACT_APP_ENV === Environment.Production;
  const isTestingShop = TESTING_SHOP.includes(search?.shop || '');
  const isGatePassed = isProduction && !isOpenFromCms && !isTestingShop;

  useEffect(() => {
    if (posthog && search && search.shop && isGatePassed) {
      // Identify user
      posthog.identify(search.shop);
      posthog.group('shop', search.shop);
      // // Capture page view for heatmap
      // posthog.capture('$pageview');
    }
  }, [posthog, search, isGatePassed]);

  // // Load toolbar manually if needed
  // useEffect(() => {
  //   if (posthog) {
  //     posthog.loadToolbar({
  //       token: process.env.REACT_APP_PUBLIC_POSTHOG_KEY || '',
  //       userEmail: 'hieuvm@omegatheme.com',
  //       actionId: undefined,
  //       userIntent: 'add-action',
  //       toolbarVersion: 'toolbar',
  //       dataAttributes: ['data-attr'],
  //       instrument: true,
  //     });
  //   }
  // }, [posthog]);

  return null;
};

export default usePostHogRecord;
